import { render, staticRenderFns } from "./WFile.vue?vue&type=template&id=765704a7&scoped=true"
import script from "./WFile.vue?vue&type=script&lang=js"
export * from "./WFile.vue?vue&type=script&lang=js"
import style0 from "./WFile.vue?vue&type=style&index=0&id=765704a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765704a7",
  null
  
)

export default component.exports